function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// ----------------------------------------------------------------------------
// Gated Cart Guard
// ----------------------------------------------------------------------------
// Provides the gating check registered with the early XHR/fetch intercept
// installed by gated-cart-guard-hook.liquid (which runs synchronously before
// content_for_header to ensure Swym's XHR caching captures our override).
//
// This mirrors the Liquid gating logic in main-product.liquid / app-wrapper.liquid
// so that third-party apps (e.g. Wishlist Plus) cannot bypass the gate.
// ----------------------------------------------------------------------------

// Tokenless — the theme access token scopes queries to its app channel (no products published there),
// causing all nodes to return null. Tokenless uses the Online Store publication context instead.
var STOREFRONT_URL = "https://".concat(window.Shopify.shop, "/api/2026-04/graphql.json");
var GATED_QUERY = "\n    query GetVariantGating($ids: [ID!]!) {\n        nodes(ids: $ids) {\n            ... on ProductVariant {\n                id\n                product {\n                    approvalType: metafield(namespace: \"gated\", key: \"approval_type\") { value }\n                    gateLevel:    metafield(namespace: \"gated\", key: \"gate_level\")    { value }\n                }\n            }\n        }\n    }\n";
var PURCHASE_GATE_LEVELS = new Set(['Purchase Options Hidden', 'Price and Purchase Options Hidden', 'Product Hidden']);
function getCustomer() {
  var _window$theme, _c$gated, _c$gated2;
  var c = ((_window$theme = window.theme) === null || _window$theme === void 0 ? void 0 : _window$theme.customer) || {};
  return {
    isLoggedIn: !!c.isLoggedIn,
    consultType: ((_c$gated = c.gated) === null || _c$gated === void 0 ? void 0 : _c$gated.consultType) || null,
    consultExpiry: parseInt((_c$gated2 = c.gated) === null || _c$gated2 === void 0 ? void 0 : _c$gated2.consultExpiry, 10) || null
  };
}
function isApproved(approvalType, customer) {
  var nowTs = Math.floor(Date.now() / 1000);
  switch (approvalType) {
    case 'Login':
      return customer.isLoggedIn;
    case 'Customer Service Consult':
      return customer.consultType === 'Customer Service Consult' || customer.consultType === 'Practitioner Consult';
    case 'Practitioner Consult':
      return customer.consultType === 'Practitioner Consult';
    case 'Practitioner Consult - Recurring':
      return customer.consultType === 'Practitioner Consult' && customer.consultExpiry !== null && customer.consultExpiry >= nowTs;
    default:
      return true;
  }
}
function findBlockedVariants(_x) {
  return _findBlockedVariants.apply(this, arguments);
}
function _findBlockedVariants() {
  _findBlockedVariants = _asyncToGenerator(function* (variantIds) {
    var gids = variantIds.map(id => "gid://shopify/ProductVariant/".concat(id));
    var response = yield fetch(STOREFRONT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        query: GATED_QUERY,
        variables: {
          ids: gids
        }
      })
    });
    var {
      data
    } = yield response.json();
    var customer = getCustomer();
    return ((data === null || data === void 0 ? void 0 : data.nodes) || []).filter(node => {
      var _node$product, _node$product2;
      // null = not in Storefront API context; fail open for logged-in, block logged-out
      if (!node) return !customer.isLoggedIn;
      var approvalType = (_node$product = node.product) === null || _node$product === void 0 || (_node$product = _node$product.approvalType) === null || _node$product === void 0 ? void 0 : _node$product.value;
      var gateLevel = (_node$product2 = node.product) === null || _node$product2 === void 0 || (_node$product2 = _node$product2.gateLevel) === null || _node$product2 === void 0 ? void 0 : _node$product2.value;
      return approvalType && PURCHASE_GATE_LEVELS.has(gateLevel) && !isApproved(approvalType, customer);
    });
  });
  return _findBlockedVariants.apply(this, arguments);
}
function extractVariantIds(body) {
  if (!body) return [];
  var ids = [];
  var processObj = obj => {
    if (obj.id) ids.push(String(obj.id));
    if (Array.isArray(obj.items)) obj.items.forEach(item => item.id && ids.push(String(item.id)));
  };
  if (body instanceof FormData || body instanceof URLSearchParams) {
    var id = body.get('id');
    if (id) ids.push(String(id));
    for (var [key, val] of body.entries()) {
      if (/^items\[\d+\]\[id\]$/.test(key)) ids.push(String(val));
    }
  } else if (typeof body === 'string') {
    try {
      processObj(JSON.parse(body));
    } catch (_unused) {
      var _id = new URLSearchParams(body).get('id');
      if (_id) ids.push(_id);
    }
  }
  return [...new Set(ids)];
}
function showBlockNotice(message) {
  var _document$getElementB;
  (_document$getElementB = document.getElementById('gated-cart-notice')) === null || _document$getElementB === void 0 || _document$getElementB.remove();
  var el = document.createElement('div');
  el.id = 'gated-cart-notice';
  el.role = 'alert';
  el.textContent = message;
  Object.assign(el.style, {
    position: 'fixed',
    top: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: '9999',
    background: '#fff',
    border: '1px solid #d9534f',
    color: '#333',
    padding: '12px 20px',
    borderRadius: '4px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    fontSize: '14px',
    maxWidth: '90vw',
    textAlign: 'center'
  });
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 5000);
}
function handleCartAdd(_x2, _x3) {
  return _handleCartAdd.apply(this, arguments);
} // Register with the early inline intercept in gated-cart-guard-hook.liquid
function _handleCartAdd() {
  _handleCartAdd = _asyncToGenerator(function* (url, body) {
    if (!url.includes('/cart/add')) return false;
    var variantIds = extractVariantIds(body);
    if (!variantIds.length) return false;
    try {
      var blocked = yield findBlockedVariants(variantIds);
      if (blocked.length) {
        var _window$translations;
        showBlockNotice(((_window$translations = window.translations) === null || _window$translations === void 0 ? void 0 : _window$translations.gatedCartBlocked) || 'This product requires approval before it can be added to cart.');
        return true;
      }
    } catch (err) {
      // Fail open — don't block on Storefront API errors
      console.error('[gated-cart-guard]', err);
    }
    return false;
  });
  return _handleCartAdd.apply(this, arguments);
}
if (window._iamCartGuard) {
  window._iamCartGuard.fn = handleCartAdd;
}